import React from 'react';
import { Menu } from 'lucide-react';

const MobileMenuButton = ({ onClick }) => {
  return (
    <button 
      onClick={onClick}
      className="md:hidden fixed top-4 right-4 z-[70] p-3 bg-black/80 backdrop-blur-sm rounded-full text-white hover:bg-black/90 active:bg-black focus:outline-none transition-all shadow-lg border border-white/10"
      aria-label="Open menu"
      data-testid="mobile-menu-button"
    >
      <Menu size={24} />
    </button>
  );
};

export default MobileMenuButton;
